import React, { useState, useEffect, useRef } from "react";
import {
  Modal,
  Button,
  Icon,
  List,
  Dropdown,
  Header,
  Image,
  Grid,
  Input,
  Form,
  Radio,
  Popup,
} from "semantic-ui-react";
import { useDispatch, useSelector } from "react-redux";
import { getRadioDataActionSet, createQuickChat } from "../../actions/dataConsoleAction";
import "../../styles/ChatScreen.css";
import "semantic-ui-css/semantic.min.css";
import { useNavigate } from "react-router-dom";

const ChatDataSet = ({ onDatasetSelect }) => {
  const dispatch = useDispatch();
  const { responseRadioDataList } = useSelector(
    (state) => state.listDatasetRadioReducer || {}
  );
  const isMounted = useRef(true);
  const [selectedValues, setSelectedValues] = useState("");
  const [radioValues, setRadioValues] = useState(null);
  const [isHandleSetDisabled, setIsHandleSetDisabled] = useState(false);
  const [UserDatsetCheckFlag, setUserDatsetCheckFlag] = useState(false);
  const [filteredDataSet, setFilteredDataSet] = useState({});
  const [datasetOptions, setDatasetOptions] = useState({});
  const [TitleValues, setTitleValues] = useState("");
  const [loginedUserName, setloginedUserName] = useState("");
  const [loginedUserType, setloginedUserType] = useState("");
  const [isCreatingQuickChat, setIsCreatingQuickChat] = useState(false);
  const [isCreatingAssistantQuickChat, setIsCreatingAssistantQuickChat] = useState(false);
  const currentUserType = useSelector((state) => state.auth.user);
  const userToken = useSelector((state) => state.auth.token);
  const navigate = useNavigate();

  useEffect(() => {
    setloginedUserName(userToken.name);
    setloginedUserType(currentUserType);
    if (isMounted.current && userToken && currentUserType) {
      getRadioDataSet();
      isMounted.current = false;
    }
  }, [currentUserType, userToken]);

  useEffect(() => {
    if (selectedValues || radioValues) {
      const datasetId = selectedValues || radioValues?.value;
      onDatasetSelect(datasetId); // Pass the datasetId to parent component
    }
  }, [selectedValues, radioValues, onDatasetSelect]);

  const getRadioDataSet = () => {
    try {
      dispatch(getRadioDataActionSet());
    } catch (error) {
      console.error("Error in getting DataSet:", error);
    }
  };

  useEffect(() => {
    if (radioValues || selectedValues) {
      setIsHandleSetDisabled(true);
    }
    if (responseRadioDataList && responseRadioDataList.length > 0) {
      getFilteredRadio(responseRadioDataList);
      setUserDatsetCheckFlag(false);
    }
    if (responseRadioDataList && responseRadioDataList.length === 0) {
      setUserDatsetCheckFlag(true);
    }
  }, [dispatch, radioValues, selectedValues, responseRadioDataList]);

  const getFilteredRadio = (response) => {
    let dataset = "";
    let radioDataSet = "";
    if (response.length > 0) {
      dataset = response.map((dataset) => {
        return {
          text: dataset.datasetName,
          value: dataset.id,
          name: dataset.datasetName,
        };
      });

      radioDataSet = dataset;
      let rows = [];
      rows = radioDataSet.slice(0, 4).reduce(function (rows, key, index) {
        return (
          (index % 2 === 0
            ? rows.push([key])
            : rows[rows.length - 1].push(key)) && rows
        );
      }, []);
      setDatasetOptions(dataset);
      setFilteredDataSet(rows);
    }
  };

  const handleDropdownChange = (event, data) => {
    const { value, name } = data.options.find(
      (option) => option.value === data.value
    );
    setSelectedValues(value);
    setRadioValues(null);
    setTitleValues(name);

    if (onDatasetSelect) {
      onDatasetSelect(value);
    }
  };

  const handleChange = (event, { value }) => {
    setRadioValues({ value });
    setSelectedValues(null);

    if (onDatasetSelect) {
      onDatasetSelect(value);
    }
  };

  const handleDataSet = async () => {
    if (isHandleSetDisabled) {
      if (selectedValues === null) {
        navigate(`/aiassistant?c=${radioValues.value}&title=${TitleValues}`);
      } else {
        navigate(`/aiassistant?c=${selectedValues}&title=${TitleValues}`);
      }
    }
  };

  const handleDataSetSummary = async () => {
    if (isHandleSetDisabled) {
      if (selectedValues === null) {
        navigate(
          `/aiassistant?summarization=1&c=${radioValues.value}&title=${TitleValues}`
        );
      } else {
        navigate(
          `/aiassistant?summarization=-1&c=${selectedValues}&title=${TitleValues}`
        );
      }
    }
  };

  const isEmpty = (value) => {
    return (
      value == null || (typeof value === "string" && value.trim().length === 0)
    );
  };

  const handleTableRowClick = (value, text) => {
    setRadioValues({ value });
    setTitleValues(text);
    setSelectedValues(null);
  };

  const handleQuickChat = async () => {
    setIsCreatingQuickChat(true);
    try {
      const result = await dispatch(createQuickChat('quickChat'));
      const { datasetId, datasetName } = result;
      
      // Redirect to chat with quick chat parameters and success flag
      navigate(`/aiassistant?c=${datasetId}&quickChat=1&method=quickChat&title=${datasetName}&success=quickChat`);
    } catch (error) {
      console.error('Failed to create quick chat dataset:', error);
      // You can add a toast notification here if needed
    } finally {
      setIsCreatingQuickChat(false);
    }
  };

  const handleAssistantQuickChat = async () => {
    setIsCreatingAssistantQuickChat(true);
    try {
      const result = await dispatch(createQuickChat('assistantQuickChat'));
      const { datasetId, datasetName } = result;
      
      // Redirect to chat with assistant quick chat parameters and success flag
      navigate(`/aiassistant?c=${datasetId}&quickChat=1&method=assistantQuickChat&title=${datasetName}&success=assistantQuickChat`);
    } catch (error) {
      console.error('Failed to create assistant quick chat dataset:', error);
      // You can add a toast notification here if needed
    } finally {
     setIsCreatingAssistantQuickChat(false);
    }
  };

  // Check if current user is Admin, OrgAdmin, or QuickChatUser
  const isAdminOrOrgAdmin = () => {
    return currentUserType === "Admin" || currentUserType === "OrgAdmin" || currentUserType === "QuickChatUser";
  };

  const isHumanAgent = currentUserType === "HumanAgent";

  if (isHumanAgent) {
    return (
      <h1 className="infferre-heading">
        Hi {loginedUserName}, You're a Support Agent.<br />
        You can only connect to Live Chat Support.
      </h1>
    );
  }

  return (
    <>
      {/* 2025-08-25: Commented out all QuickChat buttons for all user types */}
      {/* QuickChatUser quick chat button - HIDDEN */}
      {/* Admin/OrgAdmin quick chat buttons - HIDDEN */}
      
      {/* Show welcome message based on user type */}
      <h1 className="infferre-heading">
        Hi {loginedUserName}, I'm Innferre.<br />
        {currentUserType === "QuickChatUser" 
          ? "Please select the Assistant tab to get started."
          : "Please select a dataset below to get started."
        }
      </h1>

      {/* Show New Chat box for non-QuickChatUser */}
      {currentUserType !== "QuickChatUser" && (
      <div className="ui card chat-screen">
        <Header as="h3">New Chat</Header>
        {datasetOptions.length > 0 ? (
          <>
            <Header as="h5">Search or Select data set</Header>
            <Dropdown
              placeholder="Select"
              search
              selection
              options={datasetOptions.length > 0 ? datasetOptions : ""}
              onChange={handleDropdownChange}
              value={selectedValues}
              clearable
              selectOnBlur={false}
              className="dropdown-dataset"
              data-cy="dataset-dropdown-input-cy"
            />
          </>
        ) : (
          <>
            {UserDatsetCheckFlag ? (
              <>
                <Header as="h5" className="no-dataset-header">
                  Select data set
                </Header>
                <Dropdown
                  className="dropdown-dataset no-dataset-dropdown"
                  placeholder="No datasets available"
                  disabled
                />
              </>
            ) : (
              <Grid className="skelton-dataset-grid">
                <Grid.Row>
                  <Grid.Column className="skelton-dataset-grid-column" width={8}>
                    <Form.Field>
                      <div className="skeleton-view skelton-dataset-grid-div"></div>
                    </Form.Field>
                  </Grid.Column>
                  <Grid.Column width={8} className="skelton-dataset-grid-column">
                    <Form.Field>
                      <div className="skeleton-view skelton-dataset-grid-div"></div>
                    </Form.Field>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            )}
          </>
        )}

        {filteredDataSet.length > 0 ? (
          <>
            <Header className="newChatRadioHead" as="h5">
              or Add from recently approved <span>Data Console</span>
            </Header>
            <br />
          </>
        ) : (
          <>
            {UserDatsetCheckFlag ? (
              ""
            ) : (
              <Grid className="skelton-dataset-grid skelton-dataset-grid-empty">
                <Grid.Row>
                  <Grid.Column className="skelton-dataset-grid-column" width={8}>
                    <Form.Field>
                      <div className="skeleton-view skelton-dataset-grid-div"></div>
                    </Form.Field>
                  </Grid.Column>
                  <Grid.Column width={8} className="skelton-dataset-grid-column">
                    <Form.Field>
                      <div className="skeleton-view skelton-dataset-grid-div"></div>
                    </Form.Field>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            )}
          </>
        )}

        <Grid>
          {filteredDataSet.length > 0 ? (
            filteredDataSet.map((vals, index) => {
              return (
                <Grid.Row key={index} data-cy="dataset-radio-select-cy">
                  {vals.map((val, index2) => {
                    return (
                      <Grid.Column width={8} key={index2}>
                        <Form.Field
                          onClick={() => handleTableRowClick(val.value, val.text)}
                        >
                          <Radio
                            className="datasetRadioOption"
                            label={
                              val.text.length > 18 ? (
                                <Popup
                                  content={val.text}
                                  inverted
                                  position="right center"
                                  style={{ borderRadius: "15px" }}
                                  trigger={
                                    <label>
                                      {val.text.slice(0, 18) + ".."}
                                    </label>
                                  }
                                />
                              ) : (
                                val.text
                              )
                            }
                            name="radioGroup"
                            value={val.value}
                            checked={
                              !isEmpty(radioValues)
                                ? radioValues.value === val.value
                                : ""
                            }
                            onChange={handleChange}
                          />
                        </Form.Field>
                      </Grid.Column>
                    );
                  })}
                </Grid.Row>
              );
            })
          ) : (
            <>
              {!UserDatsetCheckFlag && (
                <>
                  <Grid.Row className="skelton-chat-radio-row">
                    <Grid.Column
                      width={8}
                      className="skelton-chat-radio-column"
                    >
                      <Form.Field>
                        <div className="skeleton-view skelton-chat-radio-column-div"></div>
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column
                      width={8}
                      className="skelton-chat-radio-column"
                    >
                      <Form.Field>
                        <div className="skeleton-view skelton-chat-radio-column-div"></div>
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column
                      width={8}
                      className="skelton-chat-radio-column"
                    >
                      <Form.Field>
                        <div className="skeleton-view skelton-chat-radio-column-div"></div>
                      </Form.Field>
                    </Grid.Column>
                    <Grid.Column
                      width={8}
                      className="skelton-chat-radio-column"
                    >
                      <Form.Field>
                        <div className="skeleton-view skelton-chat-radio-column-div"></div>
                      </Form.Field>
                    </Grid.Column>
                  </Grid.Row>
                </>
              )}
            </>
          )}
        </Grid>

        <Modal.Actions>
          <button
            disabled={!isHandleSetDisabled}
            className="continue-btn"
            onClick={handleDataSetSummary}
            data-cy="newchat-summarization-btn"
          >
            Summarize
          </button>
          <button
            disabled={!isHandleSetDisabled}
            className="continue-btn"
            onClick={handleDataSet}
            data-cy="newchat-continue-btn"
          >
            Question & Answer
          </button>
        </Modal.Actions>
      </div>
      )}
    </>
  );
};

export default ChatDataSet;